import GLException from '../GLException';

const GlExceptionScreen = () => {
  return <GLException reportType="trustGLException" />;
};

export default GlExceptionScreen;
